module.exports = __webpack_public_path__ + "dash_20_app_assets/img/avatar-s-4.6a665e7c.jpg";